import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { callTaskList } from "@/app/providers/directives/Resize/state"
import { useThrottle } from "@/shared/lib/utils"


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _directive_resize_init = _resolveDirective("resize-init")!

  return _withDirectives((_openBlock(), _createBlock(_component_router_view, null, null, 512)), [
    [_directive_resize_init, _unref(useThrottle)(_unref(callTaskList))]
  ])
}
}

})